export function getRatingError(value) {
  const rating = Number(value);

  if (value === '' || !Number.isFinite(rating)) {
    return 'Please enter a valid number';
  }
  if (rating < 400) {
    return 'Rating must be at least 400';
  }
  if (rating > 3400) {
    return 'Rating cannot exceed 3400';
  }
  return '';
}

export function getQuantityValidation(value, isPremium, freeMaxPuzzles = 100) {
  const quantity = Number(value);
  const maxPuzzles = isPremium ? 1000 : freeMaxPuzzles;

  if (value === '' || !Number.isFinite(quantity)) {
    return {
      error: 'Please enter a valid number',
      isValid: false,
      showUpgrade: false,
    };
  }
  if (quantity < 5) {
    return {
      error: 'Minimum 5 puzzles required',
      isValid: false,
      showUpgrade: false,
    };
  }
  if (quantity > maxPuzzles) {
    return {
      error: isPremium ? 'Maximum 1000 puzzles allowed' : '',
      isValid: false,
      showUpgrade: !isPremium,
    };
  }
  return { error: '', isValid: true, showUpgrade: false };
}
